import React from 'react';
import { DollarSign, ScrollText, Building2, Star, Send, Check } from 'lucide-react';
import Hero from '../components/ui/Hero';
import OpportunityCard from '../components/advertising/OpportunityCard';

const AdvertisingPage = () => {
  const heroImage = "https://nifmkzddenyukgjcdetc.supabase.co/storage/v1/object/public/animatronics_data/logo_light.webp";

  return (
    <div>
      <Hero
        title="Animatronics Directory Sponsorship"
        description="Connect with your audience, build your brand, and showcase your expertise in animatronics and theme park solutions."
        backgroundImage={heroImage}
        compact
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Sponsorship Options */}
        <div className="mb-16">
          <h2 className="text-2xl font-bold text-content-primary text-center mb-8">
            Sponsorship Opportunities
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            {/* Directory Listing */}
            <div className="bg-background-secondary rounded-xl p-6 border border-gray-800 hover:border-brand/50 transition-all duration-300">
              <div className="text-center mb-6">
                <h3 className="text-xl font-semibold mb-4">Get Listed in the Directory</h3>
                <p className="text-content-secondary">
                  Join our curated directory of industry suppliers and reach your target audience.
                </p>
              </div>
              <div className="space-y-3">
                <div className="flex items-start gap-3">
                  <Check className="w-5 h-5 text-brand mt-0.5 flex-shrink-0" />
                  <span>Premium Directory Listing</span>
                </div>
                <div className="flex items-start gap-3">
                  <Check className="w-5 h-5 text-brand mt-0.5 flex-shrink-0" />
                  <span>Enhanced Online Visibility</span>
                </div>
                <div className="flex items-start gap-3">
                  <Check className="w-5 h-5 text-brand mt-0.5 flex-shrink-0" />
                  <span>Connect with a Targeted Audience</span>
                </div>
              </div>
            </div>

            {/* Animatronic Sponsorship */}
            <div className="bg-gradient-to-br from-brand/5 to-background-secondary rounded-xl p-6 border border-gray-800 hover:border-brand/50 transition-all duration-300">
              <div className="text-center mb-6">
                <h3 className="text-xl font-semibold mb-4">Sponsor Individual Animatronics</h3>
                <p className="text-content-secondary">
                  Showcase your expertise by sponsoring specific animatronic entries in our database.
                </p>
              </div>
              <div className="space-y-3">
                <div className="flex items-start gap-3">
                  <Check className="w-5 h-5 text-brand mt-0.5 flex-shrink-0" />
                  <span>Exclusive Animatronic Sponsorship</span>
                </div>
                <div className="flex items-start gap-3">
                  <Check className="w-5 h-5 text-brand mt-0.5 flex-shrink-0" />
                  <span>Boost Brand Awareness</span>
                </div>
                <div className="flex items-start gap-3">
                  <Check className="w-5 h-5 text-brand mt-0.5 flex-shrink-0" />
                  <span>Strengthen Industry Credibility</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Why Advertise Section */}
        <div className="mb-16">
          <h2 className="text-2xl font-bold text-content-primary mb-8">
            Why Partner With Us?
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <OpportunityCard
              title="Targeted Exposure"
              description="Reach a passionate audience actively seeking animatronics solutions."
              icon={ScrollText}
            />
            
            <OpportunityCard
              title="Credibility"
              description="Build trust by associating your brand with our respected database."
              icon={Building2}
            />
            
            <OpportunityCard
              title="Custom Opportunities"
              description="Explore tailored advertising options to meet your goals."
              icon={Star}
              isCustom
            />
          </div>
        </div>

        {/* Contact Section */}
        <div className="bg-gradient-to-br from-brand/10 to-background rounded-2xl p-8 md:p-12">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-3xl font-bold text-content-primary mb-4">
              Join the Animatronics Industry Directory
            </h2>
            <p className="text-lg text-content-secondary mb-8">
              Contact us to discuss partnership opportunities and find the perfect solution for your business.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
              <a
                href="mailto:sales@animatronicdatabase.com"
                className="inline-flex items-center px-6 py-3 bg-brand hover:bg-brand-dark text-white rounded-lg transition-colors"
              >
                <Send className="w-5 h-5 mr-2" />
                Contact Sales Team
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdvertisingPage;